class FilterApi {
  constructor(filterApi) {
    this.clearFilters = filterApi.clearFilters;
    this.deserializeFilters = filterApi.deserializeFilters;
    this.getFilteredData = filterApi.getFilteredData;
    this.getFilterState = filterApi.getFilterState;
    this.serializeFilters = filterApi.serializeFilters;
  }
}

export { FilterApi };
